/// 顶部 --- 统计数据
export const totalConfig = {
    "冷柜非专营在控台数": "369",
    
    "60%陈列蒙牛产品自投柜数量": "941",
    "失控和空置台数": "74",
  }
  
  /// ----
  export const tableDataArr1 = 
    {
      "product": ["07-01","07-02","07-03","07-04","07-05","07-06","07-07","07-08"],
      "冷柜非专营在控台数": [3,9,5,5,4,6,3,10],
      "60%陈列蒙牛产品自投柜数量": [21,20,13,15,11,14,13,6],
      "失控和空置台数": [6,5,3,0,0,1,3,8]
    }
  export const tableDataArr2 = 
    {
      "冷柜非专营在控台数": [8,46,20,95,59,46,30,37,0,29,87,63],
      "product": ["北京","西北","豫皖","山东","华中","东北","华北","华东","上海","华南","西南","闽赣"],
      "60%陈列蒙牛产品自投柜数量": [261,66,100,30,26,22,110,2,64,63,182,0],
      "失控和空置台数": [4,3,4,8,15,10,2,3,13,12,0,0],
    }
  export const tableDimensionArr = ["product", "冷柜非专营在控台数",  "失控和空置台数","60%陈列蒙牛产品自投柜数量"]
  
  ///
  export const modernChartDataArr = [
    {
      "type": "bar",
      "stack": "vistors",
      "barWidth": "70%",
      "label": {
        "normal": {
          "show": true,
          "color": "black",
          "fontSize": 10,
          "position": "inside"
        }
      },
      "animationDuration": 2800,
      "animationEasing": "cubicInOut"
    },
    {
      "type": "bar",
      "stack": "vistors",
      "barWidth": "70%",
      "label": {
        "normal": {
          "show": true,
          "color": "black",
          "fontSize": 10,
          "position": "inside"
        }
      },
      "animationDuration": 2800,
      "animationEasing": "cubicInOut"
    },
    {
      "type": "bar",
      "stack": "vistors",
      "barWidth": "70%",
      "label": {
        "normal": {
          "show": true,
          "color": "black",
          "fontSize": 10,
          "position": "inside"
        }
      },
      "animationDuration": 2800,
      "animationEasing": "cubicInOut"
    },
    // {
    //   "type": "bar",
    //   "stack": "vistors",
    //   "barWidth": "70%",
    //   "label": {
    //     "normal": {
    //       "show": true,
    //       "color": "black",
    //       "fontSize": 10,
    //       "position": "inside"
    //     }
    //   },
    //   "animationDuration": 2800,
    //   "animationEasing": "cubicInOut"
    // },
    // {
    //   "type": "bar",
    //   "stack": "vistors",
    //   "barWidth": "70%",
    //   "label": {
    //     "normal": {
    //       "show": true,
    //       "color": "black",
    //       "fontSize": 10,
    //       "position": "inside"
    //     }
    //   },
    //   "animationDuration": 2800,
    //   "animationEasing": "cubicInOut"
    // },
    // {
    //   "type": "bar",
    //   "stack": "vistors",
    //   "barWidth": "70%",
    //   "label": {
    //     "normal": {
    //       "show": true,
    //       "color": "black",
    //       "fontSize": 10,
    //       "position": "inside"
    //     }
    //   },
    //   "animationDuration": 2800,
    //   "animationEasing": "cubicInOut"
    // }
  ]
  
  
  


// WEBPACK FOOTER //
// ./src/components/kpi/config/EightGoods.js